/** Mensajes y reglas de elegibilidad para borrar/suspender usuarios en Configuración. */

export const PROTECTED_USER_EMAILS = [
  "pruebas@bnt.local",
  "despachobnt.mty@gmail.com",
];

export function isProtectedSystemUser(u) {
  const email = String(u?.email || "").trim().toLowerCase();
  return PROTECTED_USER_EMAILS.includes(email);
}

export function resolveUserDeleteBlockReason(u, currentUserId) {
  if (!u) return "Usuario no encontrado.";
  if (isProtectedSystemUser(u)) {
    if (String(u.email || "").toLowerCase() === "pruebas@bnt.local") {
      return "El usuario diseñador/plataforma está protegido y no puede eliminarse desde esta herramienta.";
    }
    return "El comprador/titular principal está protegido. Puede editarse o suspenderse según reglas, pero no eliminarse desde limpieza.";
  }
  if (u.is_admin_owner) {
    return "No se puede eliminar al propietario del espacio de trabajo.";
  }
  if (u.is_buyer_tenant) {
    return "La cuenta comprador se gestiona desde el catálogo del distribuidor.";
  }
  if (u.id === currentUserId) {
    return "No puede eliminar su propia sesión.";
  }
  const clients = u.clients_count ?? 0;
  if (clients > 0) {
    return "Este usuario no puede eliminarse porque tiene empresas, licencias o información fiscal asociada. Primero reasigna sus empresas o suspende la cuenta.";
  }
  if (u.role === "platform_designer" || u.is_platform_designer) {
    return "El usuario diseñador/plataforma está protegido y no puede eliminarse desde esta herramienta.";
  }
  return null;
}

export function canShowDeleteButton(u, currentUserId) {
  return !resolveUserDeleteBlockReason(u, currentUserId);
}

export function canShowSuspendButton(u) {
  if (!u || isProtectedSystemUser(u)) return false;
  if (u.status === "suspended") return false;
  return Boolean(u.is_platform_designer || u.clients_count > 0 || u.has_license);
}

export function getUserRoleHint(u) {
  if (!u) return "";
  const email = String(u.email || "").toLowerCase();
  if (email === "pruebas@bnt.local" || u.role === "platform_designer") {
    return "Diseñador / plataforma BNT";
  }
  if (email === "despachobnt.mty@gmail.com" || (u.is_admin_owner && u.role === "admin")) {
    return "Comprador / titular operativo";
  }
  if (u.is_buyer_tenant || u.role === "buyer_admin") return "Comprador (portal)";
  if (u.role === "revendedor") return "Distribuidor / revendedor";
  if (u.is_admin_owner) return "Titular del espacio de trabajo";
  if (u.role === "user") return "Auxiliar contable";
  if (u.role === "consulta") return "Consulta (solo lectura)";
  return u.role || "Usuario";
}
